module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTK+5yK+6yK+2yK64yK23yK+5yK24x6+5yNr/L3sAAAAIdFJOUwDXvxqOYqU91YKbEgAAAJFJREFUKM9jYKAGYHfsQACxAoggs0cHMmgzAIsadqACYbBoBppoI9iADnQQABRlwxBVAIoyYog2AEU5RkVJFsUMSQGgKAuGaAIo3jFEwZHsgSbYgjXmBSDJBFVxiwE08SQiCYoUoKQ2Q2iiQQWs4NRBiSgbOCUhJ+skJSUliY5GIKmE0MCI6QewkQjgQJVMxQAABqQP8sdMgUwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/webht.png
// module id = VxnU
// module chunks = 0